import "../style.css";
import Modal from "components/Modal";
import LoginForm from "components/Forms/LoginForm";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";

export const LoginModal = () => {
  const current = useModalStore((s) => s.current);
  const close = useModalStore((s) => s.close);

  const isOpen = current === ModalKey.Login;

  return (
    <Modal
      isCloseIcon
      shouldCloseOnOverlayClick={false}
      modalIsOpen={isOpen}
      closeModal={close}
      title="Welcome back"
      className="p-10 login-modal-content"
    >
      {{
        content: <LoginForm closeLoginModal={close} />,
      }}
    </Modal>
  );
};

export default LoginModal;
